import { Card, CardBody, CardTitle, Container, Row, Col } from 'reactstrap';

type Props = {
  name?: string;
  parentName?: string;
};

function Header({ name, parentName }: Props) {
  return (
    <>
      <div className='header bg-info pb-6'>
        <Container fluid>
          <div className='header-body'>
            {/* 
            <Row className='align-items-center py-4'>
              <Col lg='6' xs='7'>
                <h6 className='h2 text-white d-inline-block mb-0'>{name}</h6>
                <Breadcrumb className='d-none d-md-inline-block ml-md-4' listClassName='breadcrumb-links breadcrumb-dark'>
                  <BreadcrumbItem>
                    <a href='#pablo' onClick={(e) => e.preventDefault()}>
                      <i className='fas fa-home' />
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <a href='#pablo' onClick={(e) => e.preventDefault()}>
                      {parentName}
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem aria-current='page' className='active'>
                    {name}
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col> */}
            {/* <Col className='text-right' lg='6' xs='5'>
                <Button className='btn-neutral' color='default' href='#pablo' onClick={(e) => e.preventDefault()} size='sm'>
                  New
                </Button>
                <Button className='btn-neutral' color='default' href='#pablo' onClick={(e) => e.preventDefault()} size='sm'>
                  Filters
                </Button>
              </Col> 
            </Row>
              */}

            <Row>
              <Col md='6' xl='3'>
                <Card className='card-stats'>
                  <CardBody>
                    <Row>
                      <div className='col'>
                        <CardTitle tag='h5' className='text-uppercase text-muted mb-0'>
                          Tổng lượt làm bài
                        </CardTitle>
                        <span className='h2 font-weight-bold mb-0'>0</span>
                      </div>
                      <Col className='col-auto'>
                        <div className='icon icon-shape bg-gradient-red text-white rounded-circle shadow'>
                          <i className='ni ni-active-40' />
                        </div>
                      </Col>
                    </Row>
                    <p className='mt-3 mb-0 text-sm'>
                      <span className='text-success mr-2'>
                        <i className='fa fa-arrow-up' />
                        <span> 0%</span>
                      </span>
                      <span className='text-nowrap'>Tính từ đầu tháng</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md='6' xl='3'>
                <Card className='card-stats'>
                  <CardBody>
                    <Row>
                      <div className='col'>
                        <CardTitle tag='h5' className='text-uppercase text-muted mb-0'>
                          Tổng số bài tập đã làm
                        </CardTitle>
                        <span className='h2 font-weight-bold mb-0'>0</span>
                      </div>
                      <Col className='col-auto'>
                        <div className='icon icon-shape bg-gradient-orange text-white rounded-circle shadow'>
                          <i className='ni ni-chart-pie-35' />
                        </div>
                      </Col>
                    </Row>
                    <p className='mt-3 mb-0 text-sm'>
                      <span className='text-success mr-2'>
                        <i className='fa fa-arrow-up' />
                        <span> 0%</span>
                      </span>
                      <span className='text-nowrap'>Tính từ đầu tháng</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md='6' xl='3'>
                <Card className='card-stats'>
                  <CardBody>
                    <Row>
                      <div className='col'>
                        <CardTitle tag='h5' className='text-uppercase text-muted mb-0'>
                          Điểm trung bình
                        </CardTitle>
                        <span className='h2 font-weight-bold mb-0'>0</span>
                      </div>
                      <Col className='col-auto'>
                        <div className='icon icon-shape bg-gradient-green text-white rounded-circle shadow'>
                          <i className='ni ni-money-coins' />
                        </div>
                      </Col>
                    </Row>
                    <p className='mt-3 mb-0 text-sm'>
                      <span className='text-success mr-2'>
                        <i className='fa fa-arrow-up' />
                        <span> 0%</span>
                      </span>
                      <span className='text-nowrap'>Tính từ đầu tháng</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md='6' xl='3'>
                <Card className='card-stats'>
                  <CardBody>
                    <Row>
                      <div className='col'>
                        <CardTitle tag='h5' className='text-uppercase text-muted mb-0'>
                          Tỷ lệ hoàn thành bài tập
                        </CardTitle>
                        <span className='h2 font-weight-bold mb-0'>0%</span>
                      </div>
                      <Col className='col-auto'>
                        <div className='icon icon-shape bg-gradient-primary text-white rounded-circle shadow'>
                          <i className='ni ni-chart-bar-32' />
                        </div>
                      </Col>
                    </Row>
                    <p className='mt-3 mb-0 text-sm'>
                      <span className='text-danger mr-2'>
                        <i className='fa fa-arrow-down' />
                        <span> 0%</span>
                      </span>
                      <span className='text-nowrap'>Tính từ đầu tháng</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

export default Header;
